/**
 * Dismiss -- unified close behavior for any dismissible container.
 *
 * Markup:
 *   <div class="alert" data-dismissible>
 *       ...
 *       <button class="dismiss" type="button" aria-label="Close">×</button>
 *   </div>
 *
 * Behavior:
 *   Click on a .dismiss button walks up to its nearest
 *   [data-dismissible] ancestor and calls .close() if the element has
 *   that method (native <dialog> or a custom element that implements
 *   it), otherwise .remove(). Surfaces that want exit animations
 *   implement them inside their own .close() method -- brio's core
 *   dispatcher stays animation-free.
 *
 * Programmatic:
 *   import { dismiss } from "./dismiss.js";
 *   dismiss(document.querySelector(".alert"));
 *
 * Load once:
 *   Importing this file installs a document-level click listener.
 *   Bundle or <script type="module"> it a single time per page.
 */

export function dismiss(el) {
    if (!el) return;
    if (typeof el.close === 'function') {
        el.close();
    } else {
        el.remove();
    }
}

document.addEventListener('click', (e) => {
    const btn = e.target.closest('.dismiss');
    if (!btn) return;
    const target = btn.closest('[data-dismissible]');
    if (target) dismiss(target);
});
